import { render, staticRenderFns } from "./EstablishmentStateClassified.vue?vue&type=template&id=6f2ab5c8&scoped=true&"
import script from "./EstablishmentStateClassified.vue?vue&type=script&lang=coffee&"
export * from "./EstablishmentStateClassified.vue?vue&type=script&lang=coffee&"
import style0 from "./EstablishmentStateClassified.vue?vue&type=style&index=0&id=6f2ab5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2ab5c8",
  null
  
)

component.options.__file = "EstablishmentStateClassified.vue"
export default component.exports